import { render, staticRenderFns } from "./ShopDetailsPage.vue?vue&type=template&id=1772f3ca"
import script from "./ShopDetailsPage.vue?vue&type=script&lang=js"
export * from "./ShopDetailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports